import type { MatchScorecard } from '@tark/shared/types';
import type { ReactNode } from 'react';

/** Current, authorized scores only. Previous revisions and correction controls use a separate guard. */
export function MatchScoreboards({ cards, rotating, selectedOrdinal, renderVerification }: {
  cards: MatchScorecard[]; rotating: boolean; selectedOrdinal?: number;
  renderVerification?: (card: MatchScorecard) => ReactNode;
}) {
  return <section aria-label="Recorded scorecards" className="space-y-5">
    {[...cards].sort((a,b) => Number(b.ordinal===selectedOrdinal)-Number(a.ordinal===selectedOrdinal)).map(card =>
      <section key={card.ordinal} aria-label={`${rotating?'Match':'Court'} ${card.ordinal}`}
        className={`overflow-hidden rounded-xl border bg-surface ${card.ordinal===selectedOrdinal?'border-primary':'border-border'}`}>
        <h2 className="border-b border-border p-3 font-semibold text-text">
          {card.ordinal===selectedOrdinal?'Selected · ':''}{rotating?'Match':cards.length>1?'Court':'Match result'}{rotating||cards.length>1?` ${card.ordinal}`:''}
        </h2>
        <div className="divide-y divide-border">
          {([card.sideA,card.sideB] as const).map((side,index)=><div key={index} className="flex flex-wrap items-center justify-between gap-3 p-4">
            <div className="min-w-0 flex-1 break-words font-semibold text-text">{side.players.join(' + ')||'Players unavailable'}
              {side.winner&&<p className="mt-1 text-xs text-primary-700 dark:text-primary">Winner</p>}</div>
            <div className="flex flex-wrap gap-4">{card.sets.map((set,i)=><div key={i} className="text-center text-text">
              <p className="text-xs text-text-subtle-readable">{set.format==='TB7'||set.format==='TB10'?'TB':`Set ${i+1}`}</p>
              <strong className="text-2xl tabular-nums">{(index===0?set.a??set.teamAScore:set.b??set.teamBScore)??'—'}</strong>
              {(index===0?set.tiebreakA:set.tiebreakB)!=null&&<p className="text-xs text-text-subtle-readable">TB {index===0?set.tiebreakA:set.tiebreakB}</p>}
            </div>)}</div>
          </div>)}
        </div>
        {(card.practice||!card.sets.length)&&<p className="border-t border-border p-3 text-xs text-text-subtle-readable">{card.practice?'Practice · Unrated':''}
          {!card.sets.length?'Set scores not recorded':''}</p>}
        {renderVerification?.(card)}
      </section>)}
  </section>;
}
